<template>
    <m-card923 :image="content.thumbnail" :alt="content.title">
        <template #p-1>
            <h2 class="content-card-923-title">
                {{content.title}}
            </h2>
        </template>
        <template #p-2>
            <p class="content-card-923-description" v-html="content.abstraction"></p>
        </template>
    </m-card923>
</template>

<script>
import mCard923 from '../../Cards/Card923.vue'
import mIcon from "../../Icons/Icon.vue";
import mA from "../../Tags/A.vue";
import mH5 from "../../Tags/H5.vue";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
    name: "ContentCard923",
    methods: {contentSlicer},
    props: {
        content: {}
    },
    components: {mH5, mA, mIcon, mCard923},

}
</script>


<style scoped>
.content-card-923-title {
    font-size: 16px;
    line-height: 30px;
}
.content-card-923-description {
    color: rgba(52,53,54,.6);
    font-size: 13px;
    line-height: 20px;

}
</style>